import { Component, OnInit, TemplateRef,ElementRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BranchService } from '@app/_services/masters/branch.service';
import { VerifyDocumentEventServiceService } from '@app/_services/verify-document-event-service.service';
import { VerifyDocumentService } from '@app/_services/verifyDocument.service';
import { editRequest } from '@app/_models/editRequest';
import { first } from 'rxjs/operators';
import * as _moment from 'moment';
import { Moment } from 'moment';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MatDatepicker } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DocumentVerificationListService } from '@app/_services/document-verification-list.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangeDetectorRef } from '@angular/core';

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MMMM/YYYY',
  },
  display: {
    dateInput: 'MMMM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-verify-edit-document',
  templateUrl: './verify-edit-document.component.html',
  styleUrls: ['./verify-edit-document.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class VerifyEditDocumentComponent implements OnInit {
  @ViewChild('inputFile1') myInputVariable1: ElementRef;
  editdocform: FormGroup;
  date = new FormControl(moment([2020, 1]));
  preDate = new FormControl(moment([2019, 1]))
  requiredYear
  editRequest = new editRequest();
  id
  firstName
  lastName
  enrollno
  streamid
  streamListID
  streamDropDown
  branchId 
  branchList
  semSelId 
  semesterList
  documentDropDown
  docName
  docId
  editReason
  RequestTypeDropDown
  requestTypeId
  collegeDropDown
  collegeNameId
  collegeNameVal
  filepath
  // alt_email
  uploaddocpath
  YearOfPassDropDown = []
  yearAndMonth
  yearOfPassId
  monthOfPassing
  docChange = false;
  fileSizeErr
  filePath
  submitted = false;
  altEmailLengthCheck = false;
  altEmailValidation = false;
  semId
  newFileCheck = false;
  EMAIL_REGEXP = /[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9A-Z](?:[a-z0-9A-Z]*[a-z0-9A-Z])?\.)+[a-z0-9A-Z](?:[a-z0-9A-Z]*[a-z0-9A-Z])?/;
  EmbassyDropDown = [];
  embassyidDisabled = false;
  EmbassyshowErr = false;
  form: FormGroup;
  verificationPurposeVal
  embassyName
  fillembassyname = false;

  get f() { return this.editdocform.controls; }

  

  // form = new FormGroup ({ 
  //   firstName: new FormControl(),
  //   lastName: new FormControl(),
  //   enrollno: new FormControl(),
  //   streamid: new FormControl(),
  //   branchId: new FormControl(),
  //   semid: new FormControl(),
  //   docName: new FormControl(),
  //   requestTypeId: new FormControl(),
  //   collegeNameId: new FormControl(),
  //   filepath: new FormControl(),
  //   uploaddocpath: new FormControl(),
  //   yearAndMonthSelect: new FormControl(),
  // });

  constructor(
    private fb: FormBuilder,
    private verifyDocService: VerifyDocumentService,
    private verifyDocumentEventServiceService: VerifyDocumentEventServiceService,
    private branchService: BranchService,
    private documentVerificationListService: DocumentVerificationListService,
    private modalService: NgbModal,
    private SpinnerService: NgxSpinnerService,
    private cdr: ChangeDetectorRef
  ) {
   // this.createForm();
  } 


  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
    console.log("year val==", normalizedYear)

  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    console.log("month val==", normalizedMonth)
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    datepicker.close();
    var r=this.YearOfPassDropDown.find(x => x.yearOfPassing === this.date.value.year().toString());
    // var v = moment(this.form.value.StudentDocVerificationRequest[0].yearAndMonth.month() + 1, 'MM').format('MMMM');
    //const form = (<FormArray>this.form.get("StudentDocVerificationRequest")).at(i);
    console.log("ctr val==", ctrlValue)

    this.editdocform.patchValue({
      // yearAndMonth: this.date.value,
      // yearAndMonthSelect: this.date.value,
      monthofpassing:moment(this.date.value.month()+1, 'MM').format('MMMM'),
      yearofpassid:r.id,
    });

  }

  dateFilter = (d: any): boolean => { 
    
   // console.log("d===---", d)

    // const day = (d || new Date()).getDay();
    // // Prevent Saturday and Sunday from being selected.
    // return day !== 0 && day !== 6;

    const day = d.year();
    var val = [];
    this.YearOfPassDropDown.forEach((keys: any, vals: any) => {
      var x = keys.yearOfPassing;
      var y: number = +x;
      day !== y + "";
      val.push(y);
    })
    var alphaNumeric = val.join("  && day !== ");;
    var aq = (day !== + alphaNumeric);
    var stringValueYouWant = val.join();

    return stringValueYouWant.indexOf(d.year()) !== -1;
  }
  refresh(): void {
    location.reload();
  }

  ngOnInit(): void {

    this.editdocform = this.fb.group({
      // firstName: '',
      // lastName: '',
      // enrollno: '',
      // streamid: '',
      // branchId: '',
      // semId: "",
      // docName: "",
      // requestTypeId: "",
      // collegeNameId: "",
      // filepath: "",
      // alt_email: "",
      // uploaddocpath: "",
      id: [this.id], // this.id
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      enrollno: ['', Validators.required],
      streamid: ['', Validators.required],
      branchid: ['', Validators.required],
      semid: ['', Validators.required],
      docname: ['', Validators.required],
      requesttype: ['', Validators.required],
      collegenameid: ['', Validators.required],
      alt_email: [''],
      uploaddocpath: ['', Validators.required],
      yearAndMonthSelect: [''],
      monthofpassing: [''], // this.monthOfPassing 
      yearofpassid: [''], // this.yearofpassing
      filepath: [''],
      altEmail: this.fb.control(''),
      
     //  filepath: ['', Validators.required]
    
    });

    this.verifyDocumentEventServiceService.on<any>().subscribe(
      data => {
        this.id = data
      },
      error => {
        console.log(error)
      }
    );

      // this.verifyDocService.getSemester(this.streamid)
      // .subscribe(
      //   data => {
      //     console.log("semester response---", data.respData)
      //     this.semesterList = data.respData;
      //   },
      //   error => {
      //     console.log(error)
      //   }
      // );

    this.verifyDocService.getStreams().subscribe(
      data => {
        this.streamDropDown = data.respData;
      },
      error => {
        console.log(error)
      }
    );

    this.verifyDocService.getEmbassy()
    .pipe(first())
    .subscribe(
      data => {
         console.log("getEmbassy response---", data.respData)
        this.EmbassyDropDown = data.respData;
  //     console.log("getEmbassy response---", this.EmbassyDropDown)
   // alert("Check Embassy ----"+data.id);
   //  alert('payment_id: ' + payment_id);

        // this.editdocform.value.semid = "";

      },
      error => {
        console.log(error)
      }
    )

    // this.branchService.getBranch().subscribe(
    //   data =>{
    //     this.branchList = data.respData
    //     console.log("branchlist =", this.branchList)
    //   },
    //   error => {
    //     console.log(error)
    //   }
    // );

   

      this.verifyDocService.getDocuments().subscribe(
        data => {
           console.log("Document response---", data.respData)
          this.documentDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      );

      this.verifyDocService.getRequestType().subscribe(
        data => {
          this.RequestTypeDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      );

      this.verifyDocService.getColleges().subscribe(
        data => {
          // console.log("college response---", data.respData)
          this.collegeDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      );

      this.verifyDocService.getYearOfPassing()
      .pipe(first())
      .subscribe(
        data => {
          // console.log("YearOfPassing response---", data.respData)
          this.YearOfPassDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      );

      

      this.verifyDocService.getEditVerifyDocData(this.id).subscribe(data => {
        console.log("data ====", data)
        this.editRequest = data.respData;
        // this.editRequest.upload_doc_path='C:\fakepath\11.jpg';
        // this.editdocform.controls.yearAndMonthSelect = new FormControl(moment(data.respData.year+"-"+data.respData.monthOfPassing, "YYYY-MMMM"))
        // this.editdocform.patchValue({
        //       yearAndMonthSelect : (moment(data.respData.year+"-"+data.respData.monthOfPassing, "YYYY-MMMM")),
        //       monthofpassing : data.respData.monthOfPassing,
        //       yearofpassid : data.respData.year_of_pass_id
              
        // })

        this.editdocform = this.fb.group({
          id: this.id, // this.id
          firstname: data.respData.first_name,
          lastname: data.respData.last_name,
          enrollno: data.respData.enroll_no,
          streamid: data.respData.stream_id,
          branchid: data.respData.branch_id,
          semid: data.respData.semid,
          docname: data.respData.doc_id,
          requesttype: data.respData.request_type_id,
          collegenameid: data.respData.college_name_id,
          altemail: data.respData.alt_email,
          uploaddocpath: data.respData.upload_doc_path,
          monthofpassing: data.respData.monthOfPassing, // this.monthOfPassing
          yearofpassid: data.respData.year_of_pass_id, // this.yearofpassing
          filepath: data.respData.upload_doc_path,
          yearAndMonthSelect : new FormControl(moment(data.respData.year+"-"+data.respData.monthOfPassing, "YYYY-MMMM")),
          embassyid:data.respData.embassyid,
          embassyname: data.respData.embassyname,
          embassyaddress: data.respData.embassyaddress,
          
        })
        this.editRequest = data.respData;
        this.uploaddocpath = data.respData.upload_doc_path;
        this.semId = data.respData.semid;
        this.branchId = data.respData.branch_id;
        this.collegeNameVal = data.respData.college_name_id;
        this.streamListID = data.respData.stream_id; 
        this.editReason = data.respData.editReason;
        this.myInputVariable1.nativeElement.value =data.respData.upload_doc_path;// "assets/images/thumb-up.png";
        this.verificationPurposeVal = data.respData.embassyid;
        this.embassyName= data.respData.embassyname;

        if(data.respData.embassyid == 2){

          this.embassyidDisabled = true;
        }

        console.log("emmmm" + this.verificationPurposeVal);

        this.verifyDocService.getBranch(this.streamListID)
        .subscribe(
          data => {
            console.log("branch data ++++++", data)
          this.branchList = data.respData;
          },
          error => {
            console.log(error)
          }
        )

       // Create the new date
        var myDate = new Date();
        var newDate = moment(data.respData.year+"-"+data.respData.monthOfPassing, "YYYY-MMMM");
        this.date.setValue(newDate);
        // Inject it into the initi
       
       
        this.verifyDocService.getSemester(this.streamListID)
      .subscribe(
        dataSem => {
          console.log("semester response---", dataSem.respData)
          this.semesterList = dataSem.respData;
        },
        error => {
          console.log(error)
        }
      );

      
      //this.upload_doc_path = this.upload_doc_path
        this.editRequest.year = "";
       // this.date.setValue(data.respData.monthOfPassing+"/"+data.respData.year);
       // this.date = new FormControl(moment([2020, 1]));
       //[data.respData.year, 4]
       var yer:any = Number(data.respData.year);
       console.log("data.respData====---", data.respData)

       console.log("embasyyyiddddddddd====---", data.respData.embassyid)
       

        // this.editdocform = this.fb.group({
        // firstname : data.respData.first_name,
        // lastname: data.respData.last_name,
        // enrollno: data.respData.enroll_no,
        // streamid: data.respData.stream_id,
        // branchid: data.respData.branch_id,
        // semid: data.respData.semid,
        // docname: data.respData.doc_id,
        // docId: data.respData.doc_id,
        // requesttype: data.respData.request_type_id,
        // altemail: data.respData.alt_email,
        // uploaddocpath: data.respData.upload_doc_path,
        // yearofpassid:  data.respData.year_of_pass_id, 
        // monthofpassing: data.respData.monthOfPassing, 
        //   collegenameid : 1,
        // // yearAndMonthSelect : new FormControl(moment([data.respData.year, 5]))
        //  yearAndMonthSelect : new FormControl(moment(data.respData.year+"-"+data.respData.monthOfPassing, "YYYY-MMMM"))
        //  })
        

      // this.docId = this.editRequest.doc_id

      
        
        
       /* this.id = data.respData.id
        this.firstName = data.respData.first_name
        this.lastName = data.respData.last_name  
        this.enrollno = data.respData.enroll_no  
        this.streamid = data.respData.stream_id  
        this.branchId = data.respData.branch_id  
        this.semId = data.respData.semid  
        this.docName = data.respData.doc_id  
        this.requestTypeId = data.respData.request_type_id  
        this.collegeNameId = data.respData.college_name_id  
        this.alt_email = data.respData.alt_email  
        this.uploaddocpath = data.respData.upload_doc_path  
*/
        
      });    
  }
  //ngOnInit END  

  initTimes() {
    return this.fb.group({

     embassyname: this.fb.control('NA',  this.EmbassyshowErr ? null : Validators.required),
     embassyaddress: this.fb.control('NA', this.EmbassyshowErr ? null : Validators.required),


    });
  }

  inputChanged(event: any){
    console.log('inputChanged function--->',event.target.value);
    var inputString = event.target.value;

    // var inputString = document.getElementById('emailinput').value;
    var splitInput = inputString.split(',');

    if(splitInput.length > 5){
      this.altEmailLengthCheck = true;
    }else{
      this.altEmailLengthCheck = false;
    }

    // if(splitInput.length > 5){
    //   this.alt_email = true;
    // }else{
    //   this.alt_email = false;
    // }

    var pattern = this.EMAIL_REGEXP;

    var match = true;
    var count = 0;
    for(var i=0;i<splitInput.length;i++) {
      if(!String(splitInput[i]).match(pattern)){
        match = false;
        count = count +1;
        console.log('match = false')
        this.altEmailValidation = true;
      }
    }
    if(count == 0){
      this.altEmailValidation = false;
    }
    console.log('------BOOLEAN------->',this.altEmailLengthCheck, this.altEmailValidation)
  }


  getStreamData(){
    
  }
  // createForm() {
  //   this.form = this.formBuilder.group({
  //     firstName: '',
  //     lastName: '',
  //     enrollno: '',
  //     streamid: '',
  //     branchId: '',
  //     semId: "",
  //     docName: "",
  //     requestTypeId: "",
  //     collegeNameId: "",
  //     filepath: "",
  //     alt_email: "",
  //     uploaddocpath: "",
  //   });
  // }
  strMessage;
  fillSemBranch = false;
  onSubmit(){

    // requiredYear
    //  if(this.editdocform.controls.yearAndMonthSelect.value==null || this.editdocform.controls.yearAndMonthSelect.value==undefined)
    //  {
    //    this.requiredYear="Year Required"
    //  }
    //  else
    //  {
    //   this.requiredYear=""
    //  }

    if(this.docChange == false){
      this.editdocform.value.uploaddocpath = this.uploaddocpath;
    }else{
      this.editdocform.value.uploaddocpath = this.filePath;
    }
    
    //this.form.value.yearofpassid = this.editRequest.year_of_pass_id;
   
   
    this.editdocform.value.id = this.id;
    this.submitted = true;
    console.log("main form val ==",this.editdocform.value)
    console.log("ans==",  this.editdocform)
    
    if(this.editdocform.invalid){
      console.log("errorrrrrr")
      return;
    }
    if(this.editdocform.value.semid == ""){
      this.fillSemBranch = true;
    }
    else if(this.editdocform.value.branchid == ""){
      this.fillSemBranch = true;
    }else if(this.editdocform.value.embassyid == 1 && this.editdocform.value.embassyname == ""){
      this.fillembassyname = true;
    }else if(this.editdocform.value.embassyid == 3 && this.editdocform.value.embassyname == ""){
      this.fillembassyname = true;
    }else if(this.editdocform.value.embassyid == 1 && this.editdocform.value.embassyaddress == ""){
      this.fillembassyname = true;
    }else if(this.editdocform.value.embassyid == 3 && this.editdocform.value.embassyaddress == ""){
      this.fillembassyname = true;
    }else{
      
      this.fillembassyname = false;
      console.log("main form val submited ==",this.editdocform.value)
      this.verifyDocService.editVerificationRequest(this.editdocform.value).subscribe(
        data => {
          console.log("========= main data submit ======",data)
         this.strMessage = "Verification Request updated.";
         this.modalService.open(this.showModalBoxTemplate);
        },
        error => {
          console.log(error)
        }
      )
      }
   
  }

  catchEvent(files: FileList) {
    console.log(files)
    this.docChange = true;
    this.newFileCheck = true;
    // console.log(i)
    if (files[0].size <= 5242880) {
      this.fileSizeErr = false;

      var formData = new FormData();
      formData.append("file", files.item(0));
      this.verifyDocService.uploadVerificationDocumentFile(formData)
        .subscribe(
          data => {
            console.log("file---upload---response---", data)
            this.filePath = data.respData;
            this.editdocform.value.uploaddocpath = this.filePath;
            // console.log(this.form.controls.StudentDocVerificationRequest.value[0]['uploaddocpath'])
          },
          error => {
            console.log(error)
          }
        )
    } else {
      
      this.fileSizeErr = true;
    }
  }

  document_path
  src
  fileURL
  noImage1 = false;
  isImageL = false;
  isVrPdf
  isVrImage: boolean = false;
  @ViewChild('showModalBoxImage', { read: TemplateRef }) showModalBoxImage: TemplateRef<any>;
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;

  _base64ToArrayBuffer(base64) {
    var binary_string = base64.replace(/\\n/g, '');
    binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  viewDocument(){
    console.log(this.id);
    this.documentVerificationListService.getDocument(this.id)
    .pipe(first())
    .subscribe(
      add => {
        console.log("addadd---", add, add.type)

        let reader = new FileReader();
        if (add.type == "application/pdf") {
          this.isVrPdf = true;
          this.isVrImage = false;
          reader.addEventListener("load", () => {
            this.document_path = reader.result;
            var base64Array = this.document_path.substring(28);
            console.log("=====base64Array===========", base64Array);
            this.src = this._base64ToArrayBuffer(base64Array);
            let file = new Blob([add], { type: 'application/pdf' });
            this.fileURL = URL.createObjectURL(file);
            // this.magnify('uploadImg1', 3);
          }, false);
        }
        else {
          this.isVrImage = true;
                  this.isVrPdf = false;
                  reader.addEventListener("load", () => {
                    this.document_path = reader.result;
                    this.noImage1 = false;
                    console.log(reader.result);
                    // this.magnify('uploadImg1', 3);
                  }, false);

        }
        console.log(this.isVrImage, this.isVrPdf,)
                if (add) {
                  reader.readAsDataURL(add);

                }
                this.isImageL = true;
                if (this.isVrPdf == true) {
                  var al = window.open('', 'OPEN');
                  window.setTimeout(function () { al.close() }, 100);
                }
                if (this.isImageL == true ) {
                  this.SpinnerService.hide();
                  // this.constVal = 0
                  // this.constValOriginal = 0
                  // this.modalService.open(this.showModalBoxImage, { size: 'xl', centered: true });

                  this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class', size: 'lg', centered: true });
                }

      }, error => {
        this.SpinnerService.hide();
        // this.constVal = 0
        // this.constValOriginal = 0
        // this.modalService.open(this.showModalBoxImage, { size: 'xl', centered: true });
        this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class', centered: true });
        this.document_path = "/University/assets/images/No-results-found.jpg"; // test server
        this.noImage1 = true;
        console.log(error)
      }
    )
  }
  openPdf() {
    window.open(this.fileURL);
  }


  getBranAndStream(i: any) {
    let y = i.split(':')[1];
    let id = Number(y);
    console.log(id);

    this.verifyDocService.getBranch(id)
      .pipe(first())
      .subscribe(
        data => {
          console.log("branch new response---", data.respData)
          this.branchList = data.respData;
          this.branchId = "";
          // this.editdocform.value.branchid = '';
          this.editdocform.patchValue({          
            branchid:'',
          });
          // this.f="";
        },
        error => {
          console.log(error)
        }
      )


    this.verifyDocService.getSemester(id)
      .pipe(first())
      .subscribe(
        data => {
          console.log("Sem new response---", data.respData)
          this.semesterList = data.respData;
          this.semId = "";
          // this.editdocform.value.semid = "";
          this.editdocform.patchValue({          
            semid:'',
          });
        },
        error => {
          console.log(error)
        }
      )
  }

//get embassy list
getembassylist(i: any){

  let y = i.split(':')[1];
  
      let id = Number(y);
       console.log("id-----------------" + id);    
       if (id == 1 || id ==3)  {

        this.embassyidDisabled = false;
        this.EmbassyshowErr = true;
            this.cdr.detectChanges();
            console.log("Value of embassyidDisabled:", this.embassyidDisabled);
           //   this.form.controls.embassyname.disable();
                 console.log("disable11 = ", id);

        } else{


                console.log("Enable fasle:", this.embassyidDisabled);

                this.embassyidDisabled = true;
                this.EmbassyshowErr = false;

        }
}





}